import type { Action } from "../../actions/types";

export type StoreState = number;

export const initialState = new Date().getTime();

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "SET_SCREEN_NAME":
      return new Date().getTime();
    default:
      return state;
  }
}
